<!--
1. 新增编辑表单- form 文件下
2. 移除商品功能的弹窗列表 - product-table 文件下
-->

<script>
import TablePage from '@/found/components/table_page';
import Vue from 'vue';
import FormPage from '../form/form'; // 新增表单
import productTable from '../product-table/product-table'; // 移除商品列表
import audit from '../audit/audit'; // 审核

export default {
  extends: TablePage,
  components: {
    FormPage,
    productTable,
    audit,
  },
  data() {
    return {
      formShow: false,
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
    };
  },
  mounted() {
    this.getConfigList('contract-manage-list');
  },

  methods: {
    clickVisible({
      row,
      val: { code },
    }) {
      const { ext11, ext3, processInstanceId } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (ext11 && code === 'edit' && (ext11 === '2' || ext11 === '1')) {
        return false;
      }
      if (code === 'remove_product_row' && (ext3 !== '1')) {
        return false;
      }
      if (code === 'work-flow-deal' && !processInstanceId) {
        return false;
      }
      return true;
    },
    setColumn(v) {
      const rows = v;
      if (rows.field === 'cusName') { // 客户名称
        rows.isSearch = true;
        rows.apiUrl = '/mdm/mdmCustomerMsgExtController/pageList';
        rows.paramsName = 'customerName';
        rows.optionsKey = {
          label: 'customerName',
          value: 'customerName',
        };
      }
      if (rows.field === 'ext16') { // 公司主体
        rows.isSearch = true;
        rows.paramsName = 'companyName';
        rows.apiUrl = '/mdm/companyInfo/companyPageList';
        rows.optionsKey = {
          label: 'companyName',
          value: 'companyName',
        };
      }
      return rows;
    },

    modalClick({
      val,
      row,
    }) {
      const formPageArg = {
        drawerTitle: '',
        code: val.code, // 按钮对应code
        dataCode: '', // 数据code
        formShow: true,
      };
      switch (val.code) {
        case 'add':
          formPageArg.drawerTitle = '新增';
          break;
        case 'view':
          formPageArg.drawerTitle = '查看';
          break;
        case 'edit':
          formPageArg.drawerTitle = '编辑';
          break;
        case 'remove_product_row':
          formPageArg.drawerTitle = '移除商品';
          break;
        case 'change_person':
          formPageArg.drawerTitle = '变更负责人';
          break;
        default:
          formPageArg.drawerTitle = '新增';
      }
      const codes = ['view', 'edit', 'remove_product_row', 'change_person'];
      if (codes.includes(val.code)) {
        formPageArg.dataCode = row.code;
      }
      console.log(val.code);
      const formCodes = ['add', 'edit', 'view', 'change_person'];
      if (formCodes.includes(val.code)) {
        const com = val.code !== 'remove_product' ? FormPage : productTable;
        this.createPage(formPageArg, com);
      }
      if (val.code === 'work-flow-deal') {
        console.log(formPageArg, row);
        this.createAudit(formPageArg, row);
      }
    },

    createPage(arg, page) {
      const Component = Vue.extend(page);
      const that = this;
      const vm = new Component({
        el: document.createElement('div'),
        data() {
          return {
            ...arg,
          };
        },
        methods: {
          getParentTable() {
            that.getConfigList('contract-manage-list');
          },
        },
      });
      this.vm1 = vm;
      document.body.appendChild(vm.$el);
    },
    createAudit(arg, row) {
      const Component = Vue.extend(audit);
      const vm = new Component({
        el: document.createElement('div'),
        data() {
          return {
            ...arg,
            row: { ...row },
          };
        },
      });
      this.vm1 = vm;
      document.body.appendChild(vm.$el);
    },
  },
  deactivated() {
    document.body.removeChild(this.vm1.$el);
  },
};
</script>
